(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-description"] && !Shopify.designMode) return;
  try {
    
  class CollectionDescription extends HTMLElement {
    constructor() {
      super();

      const truncatedDescElement = this.querySelector('.collection__description-truncated');
      if (truncatedDescElement) {
        this.truncateText(truncatedDescElement);
      }
    }
    connectedCallback() {}

    truncateText(element) {
      if (!element) return;

      const readMoreButton = element.querySelector('.text-button');
      if (readMoreButton) {
        readMoreButton.addEventListener('click', function (event) {
          event.preventDefault();
          element.classList.toggle('collection__description-truncated');

          if (readMoreButton.textContent.trim() === 'Read more') {
            readMoreButton.textContent = window.theme.strings.collectionDescription.readLess;
          } else {
            readMoreButton.textContent = window.theme.strings.collectionDescription.readMore;
          }
        });
      }
    }
  }
  customElements.define('collection-description', CollectionDescription);

  } catch(e) { console.error(e); }
})();
})();
